export default __webpack_public_path__ + "static/media/Tasset of the Painlegion.a297b3f4.jpg";